import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { Toaster, toast } from "sonner";
import "./index.css";

// Global Error Catchers for the Frontend to prevent silent failures
window.addEventListener('unhandledrejection', (event) => {
  console.error('⚠️ [unhandledrejection]:', event.reason);
  toast.error(event.reason?.message || "An unexpected network error occurred.");
});

window.addEventListener('error', (event) => {
  console.error('🔥 [error]:', event.error);
  toast.error(event.error?.message || "An unexpected application error occurred.");
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
